import React, { useCallback } from "react";
import { Select as AntdSelect } from "antd";
import { observer } from "mobx-react";
import ee from "../../../../services/EventEmitter";
import { CHANGE_EXPOSED_FIELD_IN_DEPARTMENTS_DATA_GROUP } from "../../../../constants/events";
import { EXPOSED_VALUES, YES_KEY } from "../../../../constants/values";
import { Option } from "../../../common/forms/Interfaces";
import { generateByKey } from "../../../../helpers/hash";
import { ChangeFieldEvent } from "../../byClientsTable/columns/interfaces";
import { EXPOSED_FIELD } from "../../../../constants/fields";
import { Item } from "../../../../models/ByClients/Item";

interface Props {
  entity: Item;
  defaultValue: string;
}

const getOptions = (options: Option[]) => {
  return options.map((option, key) => (
    <AntdSelect.Option
      key={generateByKey(key.toString(), key.toString())}
      value={option.value}
    >
      {option.title}
    </AntdSelect.Option>
  ));
};

const makeEvent = (optionValue: string, entity: Item) => {
  const ids: unknown[] = entity.children.map((item) => item.id);

  ee.emit(CHANGE_EXPOSED_FIELD_IN_DEPARTMENTS_DATA_GROUP, {
    declarantIds: ids,
    groupId: entity.key,
    key: EXPOSED_FIELD,
    value: optionValue === YES_KEY,
  } as ChangeFieldEvent);
};

const ExposedCustomGroup: React.FC<Props> = ({ entity, defaultValue }) => {
  const onChangeHandler = useCallback(
    (optionValue: string) => {
      makeEvent(optionValue, entity);
    },
    [entity]
  );

  return (
    <AntdSelect
      onClick={(event) => {
        event.stopPropagation();
      }}
      onChange={onChangeHandler}
      value={defaultValue}
      className="table-select"
      size="small"
    >
      {getOptions(EXPOSED_VALUES)}
    </AntdSelect>
  );
};

export default observer(ExposedCustomGroup);